



















import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { mdiArrowRight } from '@mdi/js'
import { IStyle } from '~/assets/interfaces/classes'
import ComponentIcon from '~/components/icon/icon.vue'

@Component({
  components: {
    ComponentIcon,
  },
})
export default class ComponentHeaderWithLink extends Vue {
  @Prop({ type: String, default: '' }) private url!: string
  // Подпись кнопки перехода: «Смотреть все», «Все видео», «Все коллекции»…
  @Prop({ type: String, default: 'Смотреть все' }) private linkText!: string

  private mounted() {
    this.$emit('loaded')
  }

  private $style!: IStyle

  private get classDevice() {
    return {
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  private mdiArrowRight = mdiArrowRight
}
